import startCase from 'lodash/startCase'

/**
 * APP MENU
 * {
 *   `entity`  used to check if current user has access to this
 *   `to`      routing path (default to /entity)
 *   `icon`    icon to shown in menu
 *   `text`    label to show in menu (default: ucfirst(entity))
 * }
 */
const menu = [
  {
    entity: 'dashboard',
    to: '/dashboard',
    icon: 'mdi-view-dashboard',
    text: 'Dashboard'
  },
  {
    type: "core-drawer-group",
    text: "Anagrafiche",
    icon: "mdi-database",
    links: [
      {
        entity: 'account',
        to: '/account',
        icon: 'mdi-account',
        text: 'Accounts'
      },
      {
        entity: 'staff',
        type: "core-drawer-link",
        to: "/staff",
        icon: "mdi-account-hard-hat",
        text: "Staff"
      },
      {
        entity: 'city',
        type: "core-drawer-link",
        to: "/city",
        icon: "mdi-city",
        text: "City"
      },
      {
        entity: 'province',
        type: "core-drawer-link",
        to: "/province",
        icon: "mdi-map-marker-radius",
        text: "Italy Province"
      },
      {
        entity: 'country',
        type: "core-drawer-link",
        to: "/country",
        icon: "mdi-map-marker",
        text: "Country"
      },
      {
        entity: 'training_category',
        type: "core-drawer-link",
        to: "/training_category",
        icon: "mdi-group",
        text: "Training Category"
      },
      {
        entity: 'template',
        type: "core-drawer-link",
        to: "/templates",
        icon: "mdi-page-layout-body",
        text: "Template"
      },
    ]
  },
  {
    entity: 'press',
    to: '/presses',
    icon: 'mdi-bullhorn',
    text: 'Press'
  },

  {
    entity: 'landingpage',
    to: '/landingpages',
    icon: 'mdi-airplane-landing',
    text: 'Landing Page'
  },

  {
    entity: 'training',
    to: '/training',
    icon: 'mdi-cast-education',
    text: 'Formazione'
  },
  
  {
    entity: 'countries_data',
    to: '/countries_data',
    icon: 'mdi-earth-box',
    text: 'Countries Data'
  },


]

export default menu.map(item => ({
  type: item.type || 'core-drawer-link',
  entity: item.entity,
  action: item.action || 'read',
  to: item.to || `/${item.entity}`,
  icon: item.icon,
  text: item.text || startCase(item.entity),
  links: item.links ?
    item.links.map(l => ({
      entity: l.entity,
      action: l.action || 'read',
      to: l.to || `/${l.entity}`,
      icon: l.icon,
      text: l.text || startCase(l.entity),      
    })) : []
}))
